import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        primary: {
            main: "#007AFF", // Vibrant Blue for primary actions
            dark: "#0056b3",
            light: "#4da3ff",
            contrastText: "#ffffff",
        },
        secondary: {
            main: "#FF2D55", // Vibrant Accent
            contrastText: "#ffffff",
        },
        background: {
            default: "#f4f6f8", // Soft light gray for app background
            paper: "#ffffff",
        },
        text: {
            primary: "#1c1c1e",
            secondary: "#8e8e93",
        },
        action: {
            hover: "rgba(0, 122, 255, 0.08)",
        },
    },
    typography: {
        fontFamily: "'Inter', sans-serif",
        h1: { fontFamily: "'Outfit', sans-serif", fontWeight: 700 },
        h2: { fontFamily: "'Outfit', sans-serif", fontWeight: 700 },
        h3: { fontFamily: "'Outfit', sans-serif", fontWeight: 600 },
        h4: { fontFamily: "'Outfit', sans-serif", fontWeight: 600 },
        h5: { fontFamily: "'Outfit', sans-serif", fontWeight: 600 },
        h6: { fontFamily: "'Outfit', sans-serif", fontWeight: 600 },
        button: {
            fontFamily: "'Inter', sans-serif",
            fontWeight: 600,
            textTransform: "capitalize", // Modern feel
        },
    },
    shape: {
        borderRadius: 12, // Softer curves generally
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: "12px",
                    padding: "10px 24px",
                    boxShadow: "none",
                    "&:hover": {
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    },
                },
                containedPrimary: {
                    background: "linear-gradient(135deg, #007AFF 0%, #00C6FF 100%)",
                    transition: 'all 0.3s ease-in-out',
                    "&:hover": {
                        background: "linear-gradient(135deg, #0056b3 0%, #0099cc 100%)",
                    }
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: "16px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.05)", // Soft, deep shadow
                    border: "1px solid rgba(0,0,0,0.03)",
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        "& fieldset": {
                            borderColor: "#e5e5ea",
                        },
                        "&:hover fieldset": {
                            borderColor: "#007AFF",
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: "#007AFF",
                            borderWidth: "2px",
                        },
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none', // Remove default elevation overlay in dark mode if switched
                }
            }
        }
    },
});

export default theme;
